import React, { useEffect, useState } from "react";
import moment from "moment";
import classes from "../../../DoctorProfile/DoctorProfile.module.css";

const SlotDateSelector = ({
  onSelect,
  selectedDate,
  fromCalender,
  calenderDate,
  track,
}) => {
  const [dateArrayState, setDateArray] = useState([]);
  useEffect(() => {
    const dateArray = [];
    if (fromCalender && !moment(calenderDate).isSame(new Date(), "day")) {
      if (
        moment(moment(calenderDate).format("YYYY MM DD")).diff(
          moment(moment(new Date()).format("YYYY MM DD")),
          "day"
        ) === 1
      ) {
        for (let i = 0; i < 7; ++i) {
          dateArray.push({
            id: i,
            date: moment().add(i, "day").format("D MMM"),
            day: moment().add(i, "day").format("dddd"),
            meta: moment().add(i, "day"),
          });
        }
        onSelect(dateArray[1]);
        setDateArray(dateArray);
      } else if (
        moment(moment(calenderDate).format("YYYY MM DD")).diff(
          moment(moment(new Date()).format("YYYY MM DD")),
          "day"
        ) === 2
      ) {
        for (let i = 0; i < 7; ++i) {
          dateArray.push({
            id: i,
            date: moment().add(i, "day").format("D MMM"),
            day: moment().add(i, "day").format("dddd"),
            meta: moment().add(i, "day"),
          });
        }
        onSelect(dateArray[2]);
        setDateArray(dateArray);
      } else if (
        moment(moment(calenderDate).format("YYYY MM DD")).diff(
          moment(moment(new Date()).format("YYYY MM DD")),
          "day"
        ) === 3
      ) {
        for (let i = 0; i < 7; ++i) {
          dateArray.push({
            id: i,
            date: moment().add(i, "day").format("D MMM"),
            day: moment().add(i, "day").format("dddd"),
            meta: moment().add(i, "day"),
          });
        }
        onSelect(dateArray[3]);
        setDateArray(dateArray);
      } else if (
        moment(moment(calenderDate).format("YYYY MM DD")).diff(
          moment(moment(new Date()).format("YYYY MM DD")),
          "day"
        ) === 90
      ) {
        for (let i = 6; i >= 0; i--) {
          dateArray.push({
            id: i,
            date: moment(calenderDate).subtract(i, "days").format("D MMM"),
            day: moment(calenderDate).subtract(i, "days").format("dddd"),
            meta: moment(calenderDate).subtract(i, "days"),
          });
        }
        onSelect(dateArray[dateArray.length - 1]);
        setDateArray(dateArray);
      } else if (
        moment(moment(calenderDate).format("YYYY MM DD")).diff(
          moment(moment(new Date()).format("YYYY MM DD")),
          "day"
        ) === 89
      ) {
        let adjustedDate = moment(calenderDate).add(1, "days")._d;
        for (let i = 6; i >= 0; i--) {
          dateArray.push({
            id: i,
            date: moment(adjustedDate).subtract(i, "days").format("D MMM"),
            day: moment(adjustedDate).subtract(i, "days").format("dddd"),
            meta: moment(adjustedDate).subtract(i, "days"),
          });
        }
        onSelect(dateArray[dateArray.length - 2]);
        setDateArray(dateArray);
      } else if (
        moment(moment(calenderDate).format("YYYY MM DD")).diff(
          moment(moment(new Date()).format("YYYY MM DD")),
          "day"
        ) === 88
      ) {
        let adjustedDate = moment(calenderDate).add(2, "days")._d;
        for (let i = 6; i >= 0; i--) {
          dateArray.push({
            id: i,
            date: moment(adjustedDate).subtract(i, "days").format("D MMM"),
            day: moment(adjustedDate).subtract(i, "days").format("dddd"),
            meta: moment(adjustedDate).subtract(i, "days"),
          });
        }
        onSelect(dateArray[dateArray.length - 3]);
        setDateArray(dateArray);
      } else {
        for (let i = 3; i >= 1; i--) {
          dateArray.push({
            id: i,
            date: moment(calenderDate).subtract(i, "days").format("D MMM"),
            day: moment(calenderDate).subtract(i, "days").format("dddd"),
            meta: moment(calenderDate).subtract(i, "days"),
          });
        }
        dateArray.push({
          id: 0,
          date: moment(calenderDate).format("D MMM"),
          day: moment(calenderDate).format("dddd"),
          meta: moment(calenderDate),
        });
        for (let i = 1; i <= 3; i++) {
          dateArray.push({
            id: i + 3,
            date: moment(calenderDate).add(i, "days").format("D MMM"),
            day: moment(calenderDate).add(i, "days").format("dddd"),
            meta: moment(calenderDate).add(i, "days"),
          });
        }
        onSelect(dateArray[3]);
        setDateArray(dateArray);
      }
    } else {
      for (let i = 0; i < 7; ++i) {
        dateArray.push({
          id: i,
          date: moment().add(i, "day").format("D MMM"),
          day: moment().add(i, "day").format("dddd"),
          meta: moment().add(i, "day"),
        });
      }
      onSelect(dateArray[0]);
      setDateArray(dateArray);
    }
  }, [track]);

  const isAfterOneYear = (date) => {
    const given = moment(date);
    const addOneYear = moment().add(12, "months");
    if (addOneYear.isAfter(given)) {
      return false;
    }
    return true;
  };

  return (
    <div className={"scrtabs-tab-container w-100 " + classes.datePicker}>
      <div className="scrtabs-tab-scroll-arrow scrtabs-tab-scroll-arrow-left">
        <span className="fa fa-angle-left" />
      </div>
      <div className="scrtabs-tabs-fixed-container">
        <div className="scrtabs-tabs-movable-container">
          <ul className="nav nav-tabs" role="tablist">
            {dateArrayState.map((date, i) => (
              <li
                role={"presentation"}
                key={date.id}
                style={{
                  background: "transparent",
                  //  selectedDate.id === date.id ? "transparent" : "transparent",
                }}
              >
                <a
                  href="#"
                  role="tab"
                  style={{
                    pointerEvents: isAfterOneYear(date?.meta._d) && "none",
                    // color: selectedDate.id === date.id ? "#f969a4" : "#7C7C7C",
                  }}
                  onClick={() => onSelect(date)}
                  data-toggle="tab"
                >
                  <h4
                    style={{
                      color: selectedDate.id === date.id ? "#1B2027" : "",
                      fontWeight: selectedDate.id === date.id ? "600" : "500",
                      borderBottom:
                        selectedDate.id === date.id ? "2px solid #f969a4" : "0",
                    }}
                  >
                    {moment(moment(date.meta._d).format("YYYY MM DD")).diff(
                      moment(moment(new Date()).format("YYYY MM DD")),
                      "day"
                    ) === 0
                      ? "Today"
                      : moment(moment(date.meta._d).format("YYYY MM DD")).diff(
                          moment(moment(new Date()).format("YYYY MM DD")),
                          "day"
                        ) === 1
                      ? "Tomorrow"
                      : date.date}
                    <span
                      style={{ textTransform: "capitalize", fontWeight: "100" }}
                    >
                      {date.day}
                    </span>
                  </h4>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SlotDateSelector;
